import styled from 'styled-components';

import { grey } from '../../theme/colors';

export const JsonPreview = styled.pre`
  background-color: ${grey.haydenGreyShade5};
  border: 1px solid ${grey.haydenGreyShade4};
  border-radius: 4px;
  padding: 16px;
  font-size: 12px;
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
`;
